import { render } from "./ModalNewTicket.vue?vue&type=template&id=2b56f6a3&scoped=true"
import script from "./ModalNewTicket.vue?vue&type=script&lang=js"
export * from "./ModalNewTicket.vue?vue&type=script&lang=js"

import "./ModalNewTicket.vue?vue&type=style&index=0&id=2b56f6a3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b56f6a3"]])

export default __exports__